<odx-area-header><h6 class="odx-title-6" i18n="@@newProject.projectForm.header.project">Projekt</h6></odx-area-header>
@if (projectForm) {
  <form odxForm [formGroup]="projectForm" class="form" [readonly]="!isWriteable()">
    <odx-form-field i18n-label="@@newProject.projectForm.label.projectName" label="Projektname">
      <input
        type="text"
        formControlName="name"
        odxFormFieldControl
        i18n-placeholder="@@newProject.projectForm.placeholder.projectName"
        placeholder="Projektname"
        [readonly]="isReadonly()"
        data-testid="projectForm.projectName"
      />
    </odx-form-field>

    <odx-form-field i18n-label="@@newProject.projectForm.label.projectVersion" label="Version">
      <input
        type="text"
        formControlName="version"
        odxFormFieldControl
        i18n-placeholder="@@newProject.projectForm.placeholder.projectVersion"
        placeholder="Version"
        [readonly]="isReadonly()"
        data-testid="projectForm.projectVersion"
      />
    </odx-form-field>

    <odx-form-field label="Projektstatus" i18n-label="@@newProject.projectForm.label.projectStatus">
      @if (!isReadonly()) {
        <odx-select formControlName="status" odxFormFieldControl>
          @for (status of projectStatuses$ | async; track status) {
            <odx-select-option [value]="status.text">
              {{ status.text | translateProjectStatus | async }}
            </odx-select-option>
          }
        </odx-select>
      }
      @if (isReadonly()) {
        <input
          odxFormFieldControl
          data-testid="status-input"
          readonly
          [value]="projectForm.get('status')?.value | translateProjectStatus | async"
        />
      }
    </odx-form-field>

    @if (isForzaIdVisible()) {
      <app-forza-id-form-field
        [isReadonly]="isReadonly()"
        [required]="isForzaIdRequired"
        [isWriteable]="isWriteable()"
      ></app-forza-id-form-field>

      @if (isReadonly()) {
        <app-forza-link-form-field
          [forzaId]="projectForm.get('forzaId')?.value"
          [valid]="!!projectForm.get('forzaId')?.valid"
        ></app-forza-link-form-field>
      }
    }

    @if (isPlaceNameVisible) {
      <app-place-name-form-field
        [isReadonly]="isReadonly()"
        [required]="isForzaIdRequired"
        [isWriteable]="isWriteable()"
      ></app-place-name-form-field>
    }

    <odx-form-field label="Land" i18n-label="@@newProject.projectForm.label.country" [readonly]="isProjectCountryFixed()">
      @if (!isReadonly() && isProjectCountryFixed() === false) {
        <odx-select formControlName="country" odxFormFieldControl>
          @for (country of (countries$ | async) ?? []; track $index) {
            <odx-select-option [value]="country.countryCode">{{ country.countryCode | mapCountryName }} </odx-select-option>
          }
        </odx-select>
      } @else {
        <input odxFormFieldControl readonly [value]="projectCountry() | mapCountryName" />
      }
    </odx-form-field>

    @if (isRegionVisible) {
      <odx-form-field label="Region" i18n-label="@@newProject.projectForm.label.region">
        @if (isReadonly()) {
          <input odxFormFieldControl readonly [value]="projectRegion! | translateProjectRegion" />
        } @else {
          <odx-select formControlName="region" odxFormFieldControl>
            @for (region of regionOptions; track region) {
              <odx-select-option [value]="region">
                {{ region | translateProjectRegion }}
              </odx-select-option>
            }
          </odx-select>
        }
      </odx-form-field>
    }

    @if (!projectInitialized) {
      <odx-inline-message i18n="@@newProject.projectForm.inlineMessage.countrySelection"
        >Es werden die für dieses Land verfügbaren Artikel und die festgelegten Preise angezeigt. Später können Sie diese
        Einstellung für dieses Projekt nicht mehr ändern.
      </odx-inline-message>
    }

    @if (isDraegerContactPersonVisible) {
      <app-draeger-contact-person-form-field
        [isReadonly]="isReadonly()"
        [required]="isDraegerContactPersonRequired"
      ></app-draeger-contact-person-form-field>
    }

    <app-opportunity-link-form-field
      [isReadonly]="isReadonly()"
      [required]="isOpportunityLinkRequired"
    ></app-opportunity-link-form-field>

    <odx-form-field i18n-label="@@newProject.projectForm.label.notes" label="Notizen">
      <textarea
        formControlName="notes"
        odxFormFieldControl
        i18n-placeholder="@@newProject.projectForm.placeholder.notes"
        placeholder="Notizen"
        class="textarea-large"
        [readonly]="isReadonly()"
        data-testid="projectForm.notes"
      ></textarea>
    </odx-form-field>
    <!--Needed to show validation errors on submit without userinput-->
    <button type="submit" class="hidden" #submitButton></button>
  </form>
}
